module.exports = "<div class=\"navtab\">\n    <div class=\"tabs\">\n        <div ng-click=\"$ctrl.clickTab(tab)\" ng-class=\"{'tab':true,'active': tab.active}\"\n             ng-repeat=\"tab in $ctrl.tabs\">{{ tab.name }}\n        </div>\n    </div>\n    <ng-transclude></ng-transclude>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/common/navtab/navtab.html
// module id = 658
// module chunks = 3